import React from 'react';
import PropTypes from 'prop-types';

const CheckIcon = ({
  width, height, fill, className, ...restProps
}) => (
  <svg
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
    {...restProps}
  >
    <path
      d="M17 4L6 14L1 9.45455"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLineJoin="round"
    />
  </svg>
);

CheckIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

CheckIcon.defaultProps = {
  width: 18,
  height: 18,
  fill: 'black',
  className: '',
};

export default CheckIcon;
